<div class="grid grid-cols-2 gap-1.5 lg:grid-cols-3 lg:gap-2">
  @for (num of iterator(); track $index) {
    <div class="rounded-xl overflow-hidden animate-pulse">
      <div class="h-36 lg:h-44 bg-gray-200 relative rounded-2xl overflow-hidden p-4 bg-zinc-200">
        <span class="sr-only">{{ num }}</span>
      </div>
      <div class="p-2 flex items-center gap-2 flex-[1]">
        <div class="w-9 h-9 rounded-full bg-gray-200 ">
        </div>
        <div class="flex-1 flex flex-col">
          <div class="rounded truncate w-[90%] h-3 mb-1 bg-gray-200 overflow-hidden"></div>
          <div class="line-clamp-1 text-xs rounded h-3 w-2/3 bg-gray-200"></div>
        </div>
      </div>
    </div>
  }
</div>
